import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './maker-board-connect-button.css';
import usbIcon from './USB_mark.png';

// 接続状態: 'disconnected' | 'connecting' | 'connected'

class MakerBoardConnectButton extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            status: 'disconnected'
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleConnecting = this.handleConnecting.bind(this);
        this.handleConnected = this.handleConnected.bind(this);
        this.handleDisconnected = this.handleDisconnected.bind(this);
    }

    componentDidMount () {
        const runtime = this.getRuntime();
        if (runtime) {
            runtime.on('MAKERBOARD_CONNECTING', this.handleConnecting);
            runtime.on('MAKERBOARD_CONNECTED', this.handleConnected);
            runtime.on('MAKERBOARD_DISCONNECTED', this.handleDisconnected);
        }
    }

    componentWillUnmount () {
        const runtime = this.getRuntime();
        if (runtime) {
            runtime.removeListener('MAKERBOARD_CONNECTING', this.handleConnecting);
            runtime.removeListener('MAKERBOARD_CONNECTED', this.handleConnected);
            runtime.removeListener('MAKERBOARD_DISCONNECTED', this.handleDisconnected);
        }
    }

    getRuntime () {
        const vm = this.props.vm;
        return (vm && vm.runtime) || null;
    }

    getExtension () {
        const runtime = this.getRuntime();
        if (!runtime) return null;
        return runtime.peripheralExtensions.makerBoardMessage || null;
    }

    handleConnecting () {
        this.setState({status: 'connecting'});
    }

    handleConnected () {
        this.setState({status: 'connected'});
    }

    handleDisconnected () {
        this.setState({status: 'disconnected'});
    }

    handleClick () {
        const ext = this.getExtension();
        if (!ext) {
            // eslint-disable-next-line no-alert
            alert('メイカーボード メッセージ拡張が読み込まれていません');
            return;
        }
        if (this.state.status === 'connecting') return;

        if (this.state.status === 'connected') {
            ext.disconnectSerial();
        } else {
            ext.connectSerial({SEC: 5});
        }
    }

    render () {
        const {status} = this.state;
        const isConnecting = status === 'connecting';
        const isConnected = status === 'connected';

        let label;
        let title;
        if (isConnected) {
            label = '接続済み';
            title = '接続済み（クリックで切断）';
        } else if (isConnecting) {
            label = '接続中…';
            title = '接続を試みています…';
        } else {
            label = '未接続';
            title = 'ボードに接続（クリックで接続）';
        }

        return (
            <div
                className={classNames(styles.connectButton, {
                    [styles.connecting]: isConnecting,
                    [styles.disabled]: isConnecting
                })}
                onClick={this.handleClick}
                title={title}
            >
                <div className={styles.iconWrapper}>
                    <img
                        className={classNames(styles.icon, {
                            [styles.iconConnected]: isConnected,
                            [styles.iconConnecting]: isConnecting
                        })}
                        src={usbIcon}
                        alt="MakerBoard接続"
                    />
                    <span
                        className={classNames(styles.statusDot, {
                            [styles.dotConnected]: isConnected,
                            [styles.dotConnecting]: isConnecting,
                            [styles.dotDisconnected]: !isConnected && !isConnecting
                        })}
                    />
                </div>
                <span
                    className={classNames(styles.label, {
                        [styles.labelConnected]: isConnected
                    })}
                >
                    {label}
                </span>
            </div>
        );
    }
}

MakerBoardConnectButton.propTypes = {
    vm: PropTypes.shape({
        runtime: PropTypes.shape({
            peripheralExtensions: PropTypes.shape({
                makerBoardMessage: PropTypes.shape({
                    connectSerial: PropTypes.func,
                    disconnectSerial: PropTypes.func
                })
            })
        })
    })
};

export default MakerBoardConnectButton;
